import mergeClasses from '../../../../../utils/shallowMerge';
import { Select } from '../../../../atoms/select/Select';
import defaultClasses from '../CartItem.module.scss';
import React from 'react';

const SelectQuantity = ({
  selectQuantityLabel,
  selectQuantityVariant,
  selectQuantityLabelPosition,
  selectQuantityDefaultValue,
  onSelect,
  customClasses,
  selectHeight,
  availableQuantity = [],
  isOutOfStock = false,
  isInsufficientStock = false,
}) => {
  const styles = mergeClasses(defaultClasses, customClasses);

  const getAvailableQty = () => {
    if (isOutOfStock) return [selectQuantityDefaultValue];
    if (availableQuantity) {
      return Array.from(
        { length: availableQuantity > 10 ? 10 : availableQuantity },
        (_, i) => i + 1,
      ).concat(isInsufficientStock ? [selectQuantityDefaultValue] : []);
    }
  };

  return (
    <Select
      selectHeight={selectHeight}
      label={selectQuantityLabel}
      variant={selectQuantityVariant}
      labelPosition={selectQuantityLabelPosition}
      onChange={onSelect}
      isDisabled={isOutOfStock}
      className={styles.qtySelector}
      dataAttributes={{
        'data-amount-product': 'amount_of_product',
      }}
    >
      {getAvailableQty()?.map((el, index) => {
        return (
          <Select.Option
            key={el}
            index={index}
            selected={el === selectQuantityDefaultValue}
            isHiddenFromDropdown={
              isInsufficientStock && el === selectQuantityDefaultValue
            }
            className={
              isInsufficientStock && el === selectQuantityDefaultValue
                ? styles.outOfStock
                : ''
            }
            label={el}
            value={el}
          />
        );
      })}
    </Select>
  );
};

export default SelectQuantity;
